import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShipperAccountInterfaceTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ShipperAccountInterfaceTypeReference');
  }
}
